"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateOnNonWebkit = exports.splitQueryString = exports.isWebkitBrowser = exports.isSamsungInternet = exports.getFirstFocusableChild = exports.encodeQueryData = exports.deepmerge = exports.canUseDOM = void 0;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _deepmerge2 = _interopRequireDefault(require("deepmerge"));
var _count = _interopRequireDefault(require("../poly/count"));
const getFirstFocusableChild = parent => parent.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0];
exports.getFirstFocusableChild = getFirstFocusableChild;
const isWebkitBrowser = () => global.window !== undefined ? global.window.navigator.userAgent.search(/webkit/i) > 0 : false;
exports.isWebkitBrowser = isWebkitBrowser;
const isSamsungInternet = () => global.window !== undefined ? global.window.navigator.userAgent.match(/SAMSUNG|SGH-[I|N|T]|GT-[I|P|N]|SM-[N|P|T|Z|G]|SHV-E|SCH-[I|J|R|S]|SPH-L/i) : false;
exports.isSamsungInternet = isSamsungInternet;
const truncateOnNonWebkit = (text, length) => {
  if (!!text && !!length) {
    return isWebkitBrowser() || text.length <= length ? text : text.substring(0, length).concat('...');
  }
  return '';
};
exports.truncateOnNonWebkit = truncateOnNonWebkit;
const deepmerge = (...items) => _deepmerge2.default.all(items.map(item => (0, _count.default)(item) === 0 ? {} : item));
exports.deepmerge = deepmerge;
const encodeQueryData = data => {
  const ret = [];
  for (let d in data) ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  return ret.join('&');
};
exports.encodeQueryData = encodeQueryData;
const splitQueryString = url => {
  const query = {};
  if (!(0, _isString.default)(url)) return query;
  const urlParts = url.split('?');
  const queryParts = urlParts.pop().split('&');
  for (let part of queryParts) {
    const parts = part.split('=');
    const key = parts[0];
    const value = parts.pop();
    if (value === key) {
      query[decodeURIComponent(key)] = true;
    } else if (isNaN(value)) {
      query[decodeURIComponent(key)] = decodeURIComponent(value);
    } else {
      query[decodeURIComponent(key)] = parseInt(decodeURIComponent(value));
    }
  }
  return query;
};
exports.splitQueryString = splitQueryString;
let canUseDOM = exports.canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);